import SearchV2 from './SearchV2'

export default SearchV2
